import React from 'react';
import { Link } from 'react-router-dom';

const Gallery = () => {
 
  const images = [
    "photo1.jpg", "photo2.jpg", "photo3.jpg", "photo4.jpg", "photo5.jpg",
    "photo6.jpg", "photo7.jpg", "photo8.jpg", "photo9.jpg", "photo10.jpg",
    "photo11.jpg", "photo12.jpg", "photo13.jpg", "photo14.jpg", "photo15.jpg",
    "photo16.jpg", "photo17.jpg", "photo18.jpg", "photo19.jpg", "photo20.jpg",
    "photo21.jpeg", "photo22.jpeg", "photo23.jpeg", "photo24.jpeg", "photo28.jpeg", 
    "photo26.jpeg", "photo27.jpeg", "photo25.jpeg","photo29.jpeg" ,"photo30.jpeg"
  ];

  return (
    <div className="gallery-wrapper">
      {/* Header Section */}
      <div className="gallery-header">
        <div className="get-to-know">
          <span>✦</span> GET TO KNOW US <span>✦</span>
        </div>
        <h1 className="main-title">
          We Exist To Help Your Business <br />
          (Re)define Success
        </h1>
        <p className="sub-description">
          We are not just an IT company; we are your strategic partner in 
          navigating the ever-evolving world of technology.
        </p>
        <Link to="/" className="home-btn">
          Take me to home <span>↗</span>
        </Link>
      </div>

      {/* Main Full Team Photo */}
      <div className="full-img-container">
        <img src="/assets/img/Gallery/G1.jpeg" alt="Galaxy Team" />
        <div className="img-overlay"></div>
        <div className="logo-overlay">
          <h2 className="logo-text">GALAXYERP</h2>
          <p className="logo-subtext">SOFTWARE</p>
        </div>
      </div>

      {/* --- 3-Column Gallery Grid --- */}
      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div className="gallery-card" key={index}>
              <div className="image-box">
                <img 
                  src={`/assets/img/Gallery/${img}`} 
                  alt={`Gallery item ${index + 1}`} 
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;